// extracted by mini-css-extract-plugin
export default {"pageTitleWrap":"PageTitle_pageTitleWrap__zDfbJ","pageTitle":"PageTitle_pageTitle__Ttxlg","subTitle":"PageTitle_subTitle__SVvrk"};